export const translatePlural = (singular: string, plural: string, amount: number): string => {
  if (amount <= 0) {
    return plural;
  }

  return amount > 1 ? plural : singular;
};
